export interface ExportOptions {
    taskId: string;
    format: 'WORD';
}

export interface TaskExportResult {
    filename: string;
    url: string;
}

/**
 * 任务导出 Service
 */
export interface TaskExportService {
    /**
     * 导出任务
     * @param options 导出设置项
     */
    exportTask(options: ExportOptions): Promise<TaskExportResult>;
}

export const TaskExportService = Symbol('TaskExportService');
